module.exports = __webpack_public_path__ + "media/images/careerplug_logo-ff54b026f604810180248e679857a0f7.svg";